import { styled } from 'opensolar-ui'

interface ProductImageProps {
  image?: string
}

export const StyledImage = styled('img')({
  width: '32px',
  height: '32px',
  marginRight: '16px',
})

export const EmptyImage = styled('img')({
  width: '13px',
  height: '13px',
})

const StyledImageContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  marginRight: '16px',
  backgroundColor: theme.palette.grey[110],
}))

export const ProductImage: React.FC<ProductImageProps> = ({ image }) => {
  return image ? (
    <StyledImage
      src={image || `${window.PUBLIC_URL}/images/component-image-placeholder.png`}
      onError={({ currentTarget }) =>
        (currentTarget.src = `${window.PUBLIC_URL}/images/component-image-placeholder.png`)
      }
    />
  ) : (
    <StyledImageContainer>
      <EmptyImage
        src={image || `${window.PUBLIC_URL}/images/component-image-placeholder.png`}
        onError={({ currentTarget }) =>
          (currentTarget.src = `${window.PUBLIC_URL}/images/component-image-placeholder.png`)
        }
      />
    </StyledImageContainer>
  )
}
